import { useAuth } from '@/lib/auth-context';
import {
  istBereichGesperrt,
  permissionsForRole,
  type Bereich,
  type Permissions,
  type Rolle,
} from './permissions';

export type { Bereich, Permissions, Rolle };
export { istBereichGesperrt, permissionsForRole };

/**
 * Rollen-Ableitungen fürs UI.
 *
 * Hintergrund: das Backend blockt die Leser-Rolle korrekt über
 * `requireWriteRole`, aber die meisten Seiten spiegelten das nicht — ein Leser
 * sah aktive Buttons („Neue Gutschrift", „Alle 12 mahnen", „Konto löschen")
 * und lief in 403-Toasts. Er konnte dadurch nicht lernen, was er darf.
 * Vorher war die Ableitung an drei Stellen kopiert; hier zentral, damit die
 * Rollen-Logik nicht an zehn Orten auseinanderdriftet.
 *
 * WICHTIG: Diese Flags sind reine Anzeige-Hilfen. Sie ersetzen keine
 * Server-Prüfung — ein Client kann jedes Flag umgehen. Jede geschützte Route
 * braucht ihr Gate backend-seitig (siehe das Gehalts-Leck vom 12.08.2026, das
 * genau daran hing: das UI graute korrekt aus, die Route war trotzdem offen).
 *
 * Die reine Ableitungsfunktion `permissionsForRole` lebt seit BL-155
 * (24.08.2026) in `./permissions` — dieser Hook re-exportiert sie nur noch,
 * damit bestehende Importe von hier unverändert funktionieren.
 */
export function usePermissions(): Permissions {
  const { user } = useAuth();
  return permissionsForRole(user?.role as Rolle | undefined, user?.gesperrteBereiche);
}
